export default "__VITE_PUBLIC_ASSET__4075fdbc__"